import { IModel } from '@/@types/models/model';
import coreFields from '../helpers/coreFields';
import buttonFields from '../helpers/buttonFields';
import commonFields from '../helpers/commonFields';

const Korisnici: IModel = {
  title: 'Korisnici',
  apiPath: 'groblja/osobe',
  layer: 'grobna_mjesta',
  minimapGfiIdAttribute: 'korisnik_id',
  forms: {
    default: {
      fields: ['oib', 'ime', 'prezime', 'kontakt', 'ulica', 'naselje', 'mjesto', 'ptt',  'drzava','adresa_full', 'external_id', 'napomena'],
    },
    insert: {
      fields: ['oib', 'ime', 'prezime', 'kontakt', 'ulica', 'naselje', 'mjesto', 'ptt', 'drzava', 'external_id', 'napomena'],
      layout: [
        { 
          title: 'common.osobni_podaci'
          , columns: 3
          , fieldNames: ['oib', 'ime', 'prezime']
        }, 
        {
          title: 'common.adresa'
          , columns: 3
          , fieldNames: ['ulica', 'naselje', 'mjesto', 'ptt', 'drzava']
        }, 
        {
          title: 'common.ostalo'
          , columns: 2
          , fieldNames: ['kontakt', 'external_id', 'napomena']
        }
      ]
    },
    update: {
      fields: ['oib', 'ime', 'prezime', 'kontakt', 'ulica', 'naselje', 'mjesto', 'ptt', 'drzava', 'adresa_full', 'external_id', 'napomena'],
      layout: [
        { 
          title: 'common.osobni_podaci'
          , columns: 3
          , fieldNames: ['oib', 'ime', 'prezime']
        }, {
          title: 'common.adresa'
          , columns: 3
          , fieldNames: ['ulica', 'naselje', 'mjesto', 'ptt', 'drzava', 'adresa_full']
        }, {
          title: 'common.ostalo'
          , columns: 2
          , fieldNames: ['kontakt', 'external_id', 'napomena']
        }
      ]
    }
  },
  listViews: {
    default: {
      fields: [
        'id',
        'oib',
        'ime',
        'prezime',
        'ime_prezime',
        'kontakt',
        'ulica',
        'naselje',
        'mjesto',
        'ptt',
        'drzava',
        'adresa_full',
        'external_id',
        'napomena',
        'docs',
        'btn_show_history',
      ],
      hidden: ['id','ime_prezime', 'external_id'],
    },
    history: {
      fields: ['id', 'oib', 'ime', 'prezime', 'ime_prezime', 'kontakt', 'ulica', 'naselje', 'mjesto', 'ptt', 'drzava', 'adresa_full', 'external_id','napomena', 'docs', 'edited'],
      hidden: ['id','ime_prezime', 'external_id'],
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'oib',
      source: 'oib',
      ttoken: 'common.oib',
      type: 'text',
      filter: true,
    },
    {
      type: 'boolean',
      source: 'has_history',
      title: 'has history',
      ttoken: 'common.has_history',
    },
    {
      title: 'ime',
      source: 'ime',
      ttoken: 'common.ime',
      type: 'text',
      filter: true,
    },

    {
      title: 'prezime',
      source: 'prezime',
      ttoken: 'common.prezime',
      type: 'text',
      filter: true,
      validation: {
        required: true,
      },
    },

    {
      title: 'ime_prezime',
      source: 'ime_prezime',
      ttoken: 'common.ime_prezime',
      type: 'text',
      filter: true,
      width: 'full'
    },

    {
      title: 'kontakt',
      source: 'kontakt',
      ttoken: 'common.kontakt',
      type: 'text',
      filter: true,
    },

    {
      title: 'ulica',
      source: 'ulica',
      ttoken: 'common.ulica',
      type: 'text',
      filter: true,
    },

    {
      title: 'mjesto',
      source: 'mjesto',
      ttoken: 'common.mjesto',
      type: 'text',
      filter: true,
    },
    {
      title: 'naselje',
      source: 'naselje',
      ttoken: 'common.naselje',
      type: 'text',
      filter: true,
    },
    {
      title: 'ptt',
      source: 'ptt',
      ttoken: 'common.postanski_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },

    {
      title: 'drzava',
      source: 'drzava',
      ttoken: 'common.drzava',
      type: 'text',
      filter: true,
    },

    {
      title: 'adresa_full',
      source: 'adresa_full',
      ttoken: 'common.adresa_full',
      type: 'text',
      filter: true,
    },
    {
      title: 'external_id',
      source: 'external_id',
      ttoken: 'common.external_id',
      type: 'text',
      filter: true,
    },
    {
      title: 'napomena',
      source: 'napomena',
      ttoken: 'common.napomena',
      type: 'multiline',
      rows: 3,
      maxRows: 10,
      width: 'full',
      filter: true
    },
    {
      title: 'is_deleted',
      source: 'is_deleted',
      ttoken: '',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      filter: true,
      readonly: true,
    },
    {
      title: 'edited',
      source: 'edited',
      ttoken: 'common.edited',
      type: 'datetime',
      filter: true,
    },
    {
      title: 'action',
      source: 'action',
      ttoken: 'common.action',
      type: 'picker',
      items: {
        labels: ['common.actions.update', 'common.actions.insert', 'common.actions.delete'],
        values: ['UPDATE', 'INSERT', 'DELETE'],
      },
      filter: true,
      translate: true,
      readonly: true,
    },
    coreFields.geom,
    coreFields.gid,
    commonFields.docsHistory,
    coreFields.created_by,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on,
    buttonFields.show_history,
  ],
};

export default Korisnici;
